import { create } from 'zustand';

/**
 * 실시간 접속자 수 (회원/비회원) — Socket.io 'online:count' 이벤트로 갱신
 */
interface OnlineState {
  members: number;
  guests: number;
  setCount: (members: number, guests: number) => void;
}

export const useOnlineStore = create<OnlineState>((set) => ({
  members: 0,
  guests: 0,
  setCount: (members, guests) => set({ members, guests }),
}));
